/* TODO: LT-29405 remove this */
import { createSelector } from '@reduxjs/toolkit';

import type { SearcherState } from './reducer';

// Get all search params:
export const getParams = (state): SearcherState =>
  state.get('searcher').toJS?.() || state.get('searcher');

// Get presenter params for Filtration:
export const getPresenterParams = createSelector(
  getParams,
  (params) => params.presenterParams,
);

export const getInitialTouristsCount = createSelector(
  getPresenterParams,
  (initialParams) => {
    const { adults, kids } = initialParams;
    return adults + (kids ? kids.length : 0);
  },
);

// Get request id:
export const getRequestId = createSelector(
  getParams,
  (params) => params.request_id,
);

// Get destination:
export const getDestination = createSelector(
  getParams,
  (params) => params.destination,
);
export const getDestinationLoading = createSelector(
  getParams,
  (params) => params.destinationLoading,
);
export const getDestinationId = createSelector(
  getDestination,
  (destionation) => destionation?.id,
);
export const getDestinationNameRu = createSelector(
  getDestination,
  (destionation) => destionation?.name_ru,
);
export const getDestinationNameEn = createSelector(
  getDestination,
  (destionation) => destionation?.name_en,
);

// Countries:
export const getAllCountries = createSelector(
  getParams,
  (params) => params.allCountries,
);
export const getAvailableCountries = createSelector(
  getParams,
  (params) => params.availableCountries,
);
export const getPriorityCountries = createSelector(
  getParams,
  (params) => params.priorityCountries,
);

// Autocomplete:
export const getAutocompleteOptions = createSelector(
  getParams,
  (params) => params.autocompleteOptions,
);
export const getAutocompleteQueryString = createSelector(
  getParams,
  (params) => params.autocompleteQueryString,
);

// Get start date:
export const getStartDate = createSelector(
  getParams,
  (params) => params.startDate,
);

export const getIsFlexDate = createSelector(
  getParams,
  (params) => params.flexDate,
);

// Get nights count:
export const getNights = createSelector(getParams, (params) => params.nights);
export const getIsFlexNights = createSelector(
  getParams,
  (params) => params.flexNights,
);

// Get tourists:
export const getAdults = createSelector(getParams, (params) => params.adults);
export const getKids = createSelector(getParams, (params) => params.kids);
export const getTouristsCount = (state) => {
  const kids = getKids(state);
  return getAdults(state) + (kids ? kids.length : 0);
};

// Get departure:
export const getDeparture = createSelector(
  getParams,
  (params) => params.departure,
);

// Departures list:
export const getDeparturesList = createSelector(
  getParams,
  (params) => params.departuresList,
);

// Search url:
export const getSearchUrl = createSelector(
  getParams,
  (params) => params.searchUrl,
);

/**
 * Ожидаем загрузки доступных стран и списка городов вылета
 * @returns {Boolean} true/false
 */
export const getIsSearcherAvailable = createSelector(
  [getAvailableCountries, getDestinationLoading],
  (availableCountries, isDestinationLoading) => {
    const isAvailable = availableCountries && !isDestinationLoading;
    return isAvailable;
  },
);
